
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Select,
  Option,
  Button,
} from 'element-ui';
import api from '@/api/course';
import { IContract } from '@/types/org.d';
import FormMixin from './formMixin';
import error from '../../../../../../../../../plugin/message/components/icon/svgs/error';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Select,
    Option,
    Button,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
  }) oldForm!: any;

  mounted() {
    this.form = Object.assign({}, this.oldForm);
  }

  getVer() {
    /* eslint-disable default-case */
    switch (this.oldForm.resourceType) {
      case 1: return 2;
      case 2: return 2;
      case 11: return 3;
      case 12: return 3;
      case 7: return 4;
      case 8: return 4;
      case 9: return 5;
      case 10: return 5;
      case 14: return 6;
      case 15: return 6;
    }
    return 2;
  }

  handleWorks(v: string) {
    const ver: number | undefined = this.getVer();
    api.getWorks(this.form.userId, v, ver).then((res:any) => {
      this.works = res.map((el:any) => ({ value: el.pid, label: el.title }));
    });
  }

  submit() {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid && this.form.projectPid) {
        api.setContract({
          pid: this.oldForm.pid,
          projectPid: this.form.projectPid,
        }).then((res: any) => {
          this.reset(true, true);
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      } else this.loading = false;
    });
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.$log({
      title: `${this.log.name}${close ? '关闭' : '重置'}`,
      component: this.log.component,
    });
    this.resetForm();
  }
}
